import { ReactNode } from "react";

import { Invoice } from "@/api/opb/opbTypes";

import InvoiceTable from "../InvoiceTable";
import InvoiceCard from "../InvoiceCard";

interface InvoiceTableCardProps {
  invoices?: Invoice[];
  isLoading: boolean;
  currencyCode: string;
  description: string;
  footer?: ReactNode;
  withAction?: boolean;
  onAction?: (invoiceId: string) => void;
  actionText?: string;
  emptyStateText?: string;
  timezone?: string;
}

function InvoiceTableCard({
  invoices = [],
  isLoading,
  currencyCode,
  description,
  footer,
  withAction,
  actionText,
  onAction,
  emptyStateText,
  timezone,
}: InvoiceTableCardProps) {
  return (
    <div className="lg:flex">
      <div className="lg:hidden">
        <InvoiceCard
          invoices={invoices}
          isLoading={isLoading}
          currencyCode={currencyCode}
          footer={footer}
          withAction={withAction}
          onAction={onAction}
          actionText={actionText}
          emptyStateText={emptyStateText}
        />
      </div>

      <div className="hidden lg:block w-full">
        <InvoiceTable
          invoices={invoices}
          isLoading={isLoading}
          currencyCode={currencyCode}
          description={description}
          footer={footer}
          withAction={withAction}
          onAction={onAction}
          actionText={actionText}
          emptyStateText={emptyStateText}
          timezone={timezone}
        />
      </div>
    </div>
  );
}

export default InvoiceTableCard;
